module.exports = "<app-resolve promise=\"$ctrl.promise\">\r\n  <section style=\"margin:0 auto\"\r\n      max-width=\"lg\">\r\n    <div class=\"ui-item flex-align-center padding-md margin-lg ng-scope\">\r\n      <h1 class=\"typo-display-1 flex\">Usuarios</h1>\r\n    </div>\r\n    <usuarios-lista\r\n        completado=\"$ctrl.completado\"\r\n        data=\"$ctrl.data\"\r\n        on-change=\"$ctrl.regresar($event.detail)\"></usuarios-lista>\r\n  </section>\r\n</app-resolve>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/usuarios/components/template.html
// module id = 3128
// module chunks = 0